import { ActionTree } from 'vuex';
import { IAlertState } from '@signing-page/alert/store/alert.store';
import { mutationAddAlert, mutationRemoveAlert } from '@signing-page/alert/store/alert.mutations';
import { IRootState } from '@signing-page/store/store';
import { IAlert } from '@/types/Alert';
import { AlertType } from '@/enums/AlertTypes';
import { ERROR_TIMEOUT, SUCCESS_TIMEOUT } from '@signing-page/common/constants/alert';

export const actionShowInfoAlert = 'showInfoAlert';
export const actionShowSuccessAlert = 'showSuccessAlert';
export const actionShowWarningAlert = 'showWarningAlert';
export const actionShowDangerAlert = 'showDangerAlert';

export const actionRemoveAlert = 'removeAlert';
export const actionAddAlert = 'addAlert';

export const actions: ActionTree<IAlertState, IRootState> = {
  async [actionShowInfoAlert]({ dispatch }, text: string) {
    const alert: IAlert = {
      text,
      type: AlertType.Info,
      timeout: SUCCESS_TIMEOUT,
    };
    dispatch(actionAddAlert, alert);
  },
  async [actionShowSuccessAlert]({ dispatch }, text: string) {
    const alert: IAlert = {
      text,
      type: AlertType.Success,
      timeout: SUCCESS_TIMEOUT,
    };
    dispatch(actionAddAlert, alert);
  },
  async [actionShowWarningAlert]({ dispatch }, text: string) {
    const alert: IAlert = {
      text,
      type: AlertType.Warning,
      timeout: ERROR_TIMEOUT,
    };
    dispatch(actionAddAlert, alert);
  },
  async [actionShowDangerAlert]({ dispatch }, text: string) {
    const alert: IAlert = {
      text,
      type: AlertType.Danger,
      timeout: ERROR_TIMEOUT,
    };
    dispatch(actionAddAlert, alert);
  },
  async [actionAddAlert]({ commit, state }, newAlert: IAlert) {
    if (state.queue.some(alert => alert.text === newAlert.text)) {
      return;
    }
    commit(mutationAddAlert, newAlert);
  },
  async [actionRemoveAlert]({ commit }) {
    commit(mutationRemoveAlert);
  },
};
